import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetSeoProductItem, SeoSettingsModel } from 'src/app/models/seo-setting/seo.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { SeoSettingService } from 'src/app/services/seo-setting.service';

@Component({
  selector: 'app-seo-setting',
  templateUrl: './seo-setting.component.html',
  styleUrls: ['./seo-setting.component.css']
})
export class SeoSettingComponent implements OnInit {
  Loader: boolean = false;
  productId: number;
  seoUpdateProduct: SeoSettingsModel;
  getSeoProductDetails: GetSeoProductItem

  constructor(private router: ActivatedRoute, private alertify: AlertifyService, private _seoProductService: SeoSettingService, private route: Router) {
    this.seoUpdateProduct = new SeoSettingsModel();
  }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.productId = param.id;
    });
    this.getProductById();
  }

  getProductById() {
    this.Loader = true;
    this._seoProductService.getSeoProductById(this.productId).subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.getSeoProductDetails = responseBody.responseData;
      this.seoUpdateProduct.SeoDescription = this.getSeoProductDetails.seoDescription;
      this.seoUpdateProduct.SeoKeyword = this.getSeoProductDetails.seoKeyword;
      this.Loader = false;
    });
  }

  onSubmit() {
    if (this.seoUpdateProduct.SeoDescription == undefined || this.seoUpdateProduct.SeoDescription == null || this.seoUpdateProduct.SeoDescription == "") {
      this.alertify.error("Seo Description is required");
      return;
    }
    if (this.seoUpdateProduct.SeoKeyword == undefined || this.seoUpdateProduct.SeoKeyword == null || this.seoUpdateProduct.SeoKeyword == "") {
      this.alertify.error("Seo Keyword is required");
      return;
    }
    this.seoUpdateProduct.Id = this.productId
    this.Loader = true;
    this._seoProductService.seoUpdateProduct(this.seoUpdateProduct)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.seoUpdateProduct = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
          this.route.navigate(['productListing']);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

}
